export default __webpack_public_path__ + "static/media/zodiac01.46aa7a9c.png";